import { getLocalLogoUrl } from '../../Common/Utils/companyLogo';
export const mapB2CTenantToLanding = (tenantData) => {
  const theme = tenantData?.theme || {};
  const topBar = tenantData?.topBar || {}; 
  const header = tenantData?.header || {};
  const footer = tenantData?.footer || {};
  const hero = tenantData?.hero || {};

  return {
    // Identity
    isPreview: tenantData?.isPreview ?? false,
    companyId:       tenantData?.companyId,
    branchId:        tenantData?.branchId, 
    userId:          tenantData?.userId,
    logoUrl: getLocalLogoUrl(tenantData?.domain),
    companyName:     tenantData?.branding?.companyName  || 'Travel Agency',
    brandName:       tenantData?.branding?.brandName    || 'Travel Agency',
    
    // Contact
    email:           tenantData?.branding?.email        || 'travelagency@gmail.com',
    phones:          tenantData?.branding?.phones       || '9098712312',
    whatsapp:        tenantData?.branding?.whatsapp     || '9081212890',
    socials:         tenantData?.branding?.socials      || {},
    companyData:     tenantData?.companyData || {},
    seo:             tenantData?.seo || {},

    // Dynamic Static Page Contents mapped to Context
    aboutUs:         tenantData?.aboutUs || {},
    contactUs:       tenantData?.contactUs || {},
    faq:             tenantData?.faq || {},
    terms:           tenantData?.terms || {},
    privacyPolicy:   tenantData?.privacyPolicy || {},
    refundPolicy:    tenantData?.refundPolicy || {},

    // Colors
    themeColor1:     theme.themeColor1 || theme.themecolor1, 
    themeColor2:     theme.themeColor2 || theme.themecolor2,
    themeColor3:     theme.themeColor3 || theme.themecolor3,
    themeColor4:     theme.themeColor4 || theme.themecolor4,
    themeColor5:     theme.themeColor5 || theme.themecolor5,

    // Overrides
    topBarBg:        topBar.bgColor || theme.themeColor2 || theme.themecolor2 || "#0B1F3A",
    topBarText:      topBar.textColor || "#ffffff",
    headerBg:        header.bgColor || theme.themeColor3 || theme.themecolor3 || "#ffffff",
    headerText:      header.textColor || "#111111",
    footerBg:        footer.bgColor   || theme.themeColor2 || theme.themecolor2 || '#1a1a1a',
    footerText:      footer.textColor || '#ffffff',

    heroData: {
        flights: {
            title:    hero.flights?.title    || "Search and Book flights.",
            subTitle: hero.flights?.subTitle || "Find the best deals.",
            textColor: hero.flights?.textColor || "#ffffff", 
            bgImage:  hero.flights?.bgImage  
        },
        hotels: {
            title:    hero.hotels?.title    || "Search and Book hotels.",
            subTitle: hero.hotels?.subTitle || "Best hotel deals.",
            textColor: hero.hotels?.textColor || "#ffffff", 
            bgImage:  hero.hotels?.bgImage 
        },
        holidays: {
            title:    hero.holidays?.title    || "Find Your Perfect Trip.",
            subTitle: hero.holidays?.subTitle || "Search deals on homes.",
            textColor: hero.holidays?.textColor || "#ffffff", 
            bgImage:  hero.holidays?.bgImage  
        },
        sightseeing: {
            title:    hero.sightseeing?.title    || "Search and Book Activities.",
            subTitle: hero.sightseeing?.subTitle || "Find the best activities.",
            textColor: hero.sightseeing?.textColor || "#ffffff", 
            bgImage:  hero.sightseeing?.bgImage  
        }
    }
  };
};

// 2. Color Resolver for B2C T2
export const getB2CColors_T2 = (landingData) => {
  const c1 = landingData.themeColor1 || "#44baab";

  return {
    theme1: c1,                                  // Gold
    theme2: landingData.footerBg || "#0B1F3A",   // Dark Navy
    theme3: landingData.headerBg || "#ffffff",   // White Header
    theme4: landingData.themeColor4 || "#F5F7FA",
    theme5: landingData.themeColor5 || "#111111",

    headerText: landingData.headerText || "#111111",
    footerText: landingData.footerText || "#ffffff",

    topBarBg: landingData.topBarBg || "#0B1F3A",
    topBarText: landingData.topBarText || "#ffffff",
  };
};